import { VehicleSetting } from '@app/modules/client/map/map-details/shared/vehicle-setting.model'

export const vehicleSettings: VehicleSetting[] = [
  { property: 'lastCoordinates', isActive: true, isShown: true },
  { property: 'address', isActive: true, isShown: true },
  { property: 'defaultLabel', isActive: true, isShown: true },
  { property: 'driver', isActive: true, isShown: true },
  { property: 'groups', isActive: true, isShown: true },
  { property: 'depot', isActive: true, isShown: true },
  { property: 'temperatureLevel', isActive: true, isShown: true },
  { property: 'areas', isActive: true, isShown: true },
  { property: 'mileage', isActive: true, isShown: true },
  { property: 'engineHours', isActive: true, isShown: true },
  { property: 'externalVoltage', isActive: true, isShown: true },
  { property: 'lastDataReceived', isActive: true, isShown: true },
]
